import React from "react";
// import useEmblaCarousel from "embla-carousel-react";
// import Autoplay from "embla-carousel-autoplay";
import "../App.css";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

export const ContactInfo = () => {
  return (
    <div className="relative flex items-center bg-gray-100">
      <div className="absolute top-0 right-0 w-[95%] md:w-[560px] h-[400px] bg-[#07775D] rounded-[25px] shadow-lg"></div>

      <div className="relative z-10 md:mt-4 bg-white w-[95%] md:w-[550px] h-[400px] p-8 rounded-[25px] shadow-xl flex flex-col justify-center items-center text-center">
        <h2 className="text-3xl font-bold mb-6">Contact us</h2>
        <p className="text-gray-600 text-lg mb-8 leading-relaxed">
          Our support team is always ready to answer your questions and discuss our products.
          Reach out to us directly and we'll get back to you as soon as possible.
        </p>

        <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#07775D]">
          <p className="text-sm text-gray-600 mb-2">Email us at:</p>
          <a
            href="mailto:support@uniswitch.com"
            className="text-2xl font-semibold text-[#07775D] hover:text-green-700 transition-colors"
          >
            support@uniswitchng.com
          </a>
        </div>
      </div>
    </div>
  );
};

export const HeroSection = () => {
  // const [emblaRef] = useEmblaCarousel({ loop: false }, [Autoplay()]);
  return (
    <section
      id="about"
      className="container mx-auto md:px-[5em] flex flex-col-reverse justify-center md:flex-row mt-32 py-16 animate-slidein"
    >
      <div className="w-full md:w-1/2 p-4">
        <h2 className="text-2xl md:text-[3.5rem] font-bold mb-4 leading-normal">
          Need Help? <br />
          We're Here for You!
        </h2>
        <p className="text-gray-800 text-lg">
          Get in touch with our support team for quick assistance. Whether you
          have questions or need help, we're just a message away.
        </p>
      </div>
      <div className="w-full md:w-[35em] p-2 flex md:justify-end">
        <ContactInfo />
      </div>
    </section>
  );
};

export const Support = () => (
  <div className="font-sans pt-6">
    <Navbar />
    <HeroSection />
    <Footer />
  </div>
);

export default Support;
